import React, { Component, useState } from 'react';
import styled from 'styled-components';
import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { Formik, Form } from 'formik';
import TextInput from '../components/TextInput';
import { FormField } from '../components/FormField';
import { ADMIN_TRANSFORM_TO_BRIDGE } from '../graphql';
import { compose, Query, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications/dist/ToastProvider';
import PleaseWait from '../components/PleaseWait';
import ConfirmModal from '../components/ConfirmModal';

const Container = styled(Box)`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding-top: 48px;
`;
const ModalInner = styled(Box)`
  max-width: 800px;
  width: 100%;
`;

const TransformAppointmentToBridge = ({ toastManager, client }) => {
  const [result, setResult] = useState();
  const [formActions, setFormActions] = useState();
  const [isModalVisible, setIsModalVisible] = useState();

  const cancel = () => {
    setFormActions(null);
    setIsModalVisible(false);
  };
  const submitChange = async (appointmentId, patientId, formActions) => {
    formActions.setSubmitting(true);

    try {
      const res = await client.mutate({
        mutation: ADMIN_TRANSFORM_TO_BRIDGE,
        variables: {
          appointmentId,
          patientId,
        },
      });

      if (res && res.data && res.data.transformToBridge) {
        setResult(res.data.transformToBridge);
      } else {
        formActions.resetForm();
        formActions.setSubmitting(false);
        toastManager.add('Error updating, please try again', {
          appearance: 'error',
        });
        return;
      }

      formActions.setSubmitting(false);
      //   toastManager.add('Error submitting intake form', { appearance: 'error' });
    } catch (err) {
      console.log('Tranasform to bridge Err', err);
      formActions.setSubmitting(false);
      toastManager.add('Error updating, please try again', {
        appearance: 'error',
      });
      return;
    }
    setIsModalVisible(true);
  };
  const handleSubmit = async (values, actions) => {
    actions.setSubmitting(true);
    // setFormActions(actions);

    submitChange(values.appointmentId, values.athenaId, actions);
  };

  return (
    <Container>
      <Flex m={[3, 5]} flex={1} flexDirection="column">
        <Heading mb={4} mt={[3, 0]} ml={[1, 0]} fontSize={[4, 5]}>
          Move appointment to Bridge
        </Heading>
        <Card mb={4} p={[3, 4]}>
          <Flex flexDirection={'column'} flex={1} alignItems="center">
            <Formik
              initialValues={{ athenaId: '', appointmentId: '' }}
              // validationSchema={schema}
              onSubmit={(values, actions) => handleSubmit(values, actions)}
              render={({ errors, touched, isValid, isSubmitting, handleChange, handleBlur, values }) => (
                <Form style={{ width: '300px' }}>
                  <Flex flexDirection="column" flex={1}>
                    <Heading mb={4}>Athena ID</Heading>
                  </Flex>
                  <FormField mb={4} error={touched.athenaId && errors.athenaId}>
                    <TextInput placeholder="Athena ID" name="athenaId" />
                  </FormField>
                  <Flex flexDirection="column" flex={1}>
                    <Heading mb={4}>Appointment ID</Heading>
                  </Flex>
                  <FormField mb={4} error={touched.appointmentId && errors.appointmentId}>
                    <TextInput placeholder="Appointment ID" name="appointmentId" />
                  </FormField>

                  <Button mt={4} mb={4} variant="primary" width={1 / 2} disabled={!isValid || isSubmitting} type="submit">
                    Change
                  </Button>
                </Form>
              )}
            />
          </Flex>
        </Card>
      </Flex>

      {isModalVisible &&
        result && (
          <ConfirmModal
            isOpen={true}
            onClose={() => cancel()}
            onBackgroundClick={() => cancel()}
            onEscapeKeydown={() => cancel()}
            onConfirm={() => {}}
            confirmLabel="Save"
            cancelLabel="Remove"
            confirmStyle={{
              width: '100%',
            }}
            cancelStyle={{
              width: '100%',
              marginTop: '18px',
            }}
            childrenManaged
            cancelVariant="outline"
            buttonsDirection="column"
            displayX={true}
            cardStyle={{
              width: '500px',
              maxWidth: 'calc(100vw - 40px)',
            }}
          >
            <ModalInner>
              <Heading mb={4} textAlign="center" fontWeight="bold">
                Result
              </Heading>
              <Text>appointmentId: {result.appointmentId}</Text>
              <Text>clinicalEncounterId: {result.clinicalEncounterId}</Text>
              <Text>appointmentDuration: {result.appointmentDuration}</Text>
              <Text>appointmentTypeId: {result.appointmentTypeId}</Text>
              <Text>bridgeServiceId: {result.bridgeServiceId}</Text>
              <Text>done: {result.done}</Text>
              <Text>error: {result.error}</Text>
              <Text>step: {result.step}</Text>
            </ModalInner>
          </ConfirmModal>
        )}
    </Container>
  );
};

export default compose(
  withApollo,
  withToastManager
)(TransformAppointmentToBridge);
